<script>
    import { onMount, onDestroy } from "svelte";
    import { getPosts } from "../getPosts.js";
    import { store } from "../store.js";
    import Select from "svelte-select";
    import { getTerms } from "../getTerms.js";

    // Le filtre par lieu

    let cat_terms = [],
        cat_value;

    onMount(async () => {
        // Les lieux
        let categoriesJSON = await getTerms("category");
        let filteredTerms = categoriesJSON.map((term) => {
            return {
                value: term.slug,
                label: term.name,
            };
        });
        cat_terms = filteredTerms;
        categoriesJSON.map((term) => {
            //console.log($store.options[$$props.id].filtresParDefaut.taxonomies.search(term.slug))
            if (
                $store.options[$$props.id].filtresParDefaut.taxonomies.search(term.slug) != -1
            ) {
                cat_value = {
                    value: term.slug,
                    label: term.name,
                };
            }
        });

        $store.options[$$props.id].loading = false;
    });

    async function filter_by_cat(event) {
        $store.options[$$props.id].loading = true;

        let tax_params = "%5B%7B%22taxonomy%22%3A%22category%22%2C%22field%22%3A%22slug%22%2C%22terms%22%3A%22"+ event.detail.value +"%22%7D%5D";

        $store.options[$$props.id].filtres.taxonomies = tax_params;
        
        let params = new URLSearchParams(
            $store.options[$$props.id].filtres
        ).toString();

        let myPosts = await getPosts(params);
        $store.posts[$$props.id] = myPosts;
        $store.options[$$props.id].found_posts = myPosts.found_posts;
        $store.options[$$props.id].max_num_pages = myPosts.max_num_pages;
        $store.options[$$props.id].loading = false;
    }

    async function unfilter_cat(event) {
        $store.options[$$props.id].loading = true;

        delete $store.options[$$props.id].filtres.taxonomies;

        let params = new URLSearchParams(
            $store.options[$$props.id].filtres
        ).toString();

        let myPosts = await getPosts(params);
        $store.posts[$$props.id] = myPosts;
        $store.options[$$props.id].found_posts = myPosts.found_posts;
        $store.options[$$props.id].max_num_pages = myPosts.max_num_pages;
        $store.options[$$props.id].loading = false;
    }
</script>

<div class="filter_select filter_by_location filter_by_categories">
    <Select

        items={cat_terms}
        value={cat_value}
        showChevron={true}
        placeholder={"Toutes les catégories"}
        placeholderAlwaysShow={true}
        on:select={filter_by_cat}
        on:clear={unfilter_cat}
    />
</div>


<style>
    :root {
        --inputPadding: 0;
        --internalPadding: 0;
    }
  </style>